import { createContext } from "react";
export const ThemeContext = createContext("");

export const ViewContext = createContext("");

export const AccessProjectContext = createContext("");
